<script lang="ts">
/**
 * @deprecated
 */
export default {};
</script>

<script setup lang="ts">
import { useForwardExpose, useForwardProps } from "reka-ui";
import type { TooltipProps } from "./Tooltip.vue";
import Tooltip from "./Tooltip.vue";

const props = defineProps<TooltipProps>();
const forwarded = useForwardProps(props);

defineSlots<{
	default(): void;
	tooltip(): void;
}>();

const { forwardRef } = useForwardExpose();
</script>

<template>
	<Tooltip :ref="forwardRef" v-bind="{ ...forwarded }">
		<slot />

		<template #tooltip>
			<slot name="tooltip" />
		</template>
	</Tooltip>
</template>
